import React from 'react';
import { Box, Table } from '@mui/material';
import TableColumnHeaders from './TableColumnHeaders';

interface ReportTableHeaderProps {
  columns: string[];
  leftContent: React.ReactNode;
}

const ReportTableHeader: React.FC<ReportTableHeaderProps> = ({ columns, leftContent }) => {
  return (
    <Box sx={{ display: 'grid', mb: 1 }}>
      <Box
        sx={{
          gridArea: '1/1',
          zIndex: 1,
          width: 'fit-content',
        }}>
        {leftContent}
      </Box>
      <Box
        sx={{
          gridArea: '1/1',
          zIndex: 0,
          display: 'flex',
          alignItems: 'flex-end',
        }}>
        <Table>
          <TableColumnHeaders columns={columns} />
        </Table>
      </Box>
    </Box>
  );
};

export default ReportTableHeader;
